import React, { useState } from "react";
import styled from "styled-components";
import { GiFilmSpool } from "react-icons/gi";

import { TfiSave } from "react-icons/tfi";

import Button from "./Button.tsx";

import { useQuery } from "@tanstack/react-query";

import {
  addNewCompatibility,
  getFilaments,
} from "../../../services/filamentService.js";
import SimpleDropdown from "./SimpleDropdown.tsx";
import { useSelector } from "react-redux";

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 2rem 2rem;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    min-width: 200px;
  }
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1rem;
`;

const Title = styled.p`
  color: var(--secondary-font-color);
  font-family: Georgia, serif;
  letter-spacing: 1px;
  margin: 0;
  font-weight: 700;
`;

export type FilamentConfig = {
  material: string;
  supplierName: string;
  spoolWeight: number;
  weight: number;
  temperature: number;
  filamentID: number;
};

interface Props {
  closeAddMode: (string) => void;
  printerId: string;
}

const AddFilamentCompatibility: React.FC<Props> = ({
  closeAddMode,
  printerId,
}) => {
  const activePrinter = useSelector((state: any) => state.data.activePrinter);
  const [errorMsg, setErrorMsg] = useState("");
  const [filamentId, setFilamentId] = useState("");
  const [isError, setIsError] = useState(false);

  const { data: filaments, refetch } = useQuery({
    queryKey: ["filaments"],
    queryFn: getFilaments,
  });

  const isCompatible = (filamentId) => {
    if (!activePrinter) return true;
    const selectedFilament = filaments.find(
      (filament) => filament?.filamentConfig.filamentID == filamentId
    );

    return selectedFilament
      ? selectedFilament.filamentConfig.temperature <=
          activePrinter?.maxNozzleTemp
      : false;
  };

  const handleSave = async () => {
    if (filamentId) {
      if (isCompatible(filamentId)) {
        setIsError(false);
        try {
          await addNewCompatibility(printerId, filamentId);
          closeAddMode("success");
        } catch (error) {
          closeAddMode("error");
        }
      } else {
        setErrorMsg(
          "Filamentul selectat are o temperatură de topire mai mare decât temperatura maximă a imprimantei."
        );
        setIsError(true);
      }
    } else {
      setErrorMsg("Alege un filament !");
      setIsError(true);
    }
  };

  return (
    <Wrapper data-testid="add-filament-tile">
      <Container>
        <Title>Selectează un filament după id</Title>
        <SimpleDropdown
          values={
            filaments &&
            filaments.map((filament) => ({
              value: filament?.filamentConfig.filamentID,
              label: `id ${filament?.filamentConfig.filamentID} - ${filament?.filamentConfig.material} - ${filament?.colorName}`,
            }))
          }
          name="supplier"
          icon={<GiFilmSpool />}
          onChange={({ value, label }) => {
            setFilamentId(value);
          }}
        />

        {isError && <p style={{ color: "#c72418", margin: 0 }}>{errorMsg}</p>}
        <Buttons>
          <Button
            id="save-filament"
            onClick={handleSave}
            text="SAVE"
            icon={<TfiSave />}
            backgroundColor={"var(--secondary-green)"}
            color="white"
          />
        </Buttons>
      </Container>
    </Wrapper>
  );
};

export default AddFilamentCompatibility;
